import React from "react";

export default function ClosingBand() {
    return (
        <section
            data-testid="closing-band"
            className="relative overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-10 md:py-28">
                <div className="mx-auto max-w-3xl text-center">
                    <p className="text-xs uppercase tracking-[0.45em] text-brand-goldSoft">
                        Our Promise
                    </p>
                    <h3 className="mt-6 font-serif text-4xl leading-tight text-brand-ivory sm:text-5xl md:text-6xl">
                        We don't just
                        <span className="gold-text"> sell insurance.</span>
                        <br />
                        We <span className="gold-text">stand by you.</span>
                    </h3>
                    <div className="gold-hairline mx-auto my-8 w-40" />
                    <p className="text-base text-brand-muted md:text-lg">
                        Licensed where required. Personal guidance from a
                        licensed agent — by phone or email.
                    </p>

                    <div className="mt-10 flex justify-center">
                        <a
                            data-testid="closing-cta"
                            href="tel:+18559007405"
                            className="inline-flex items-center gap-3 rounded-full border border-brand-gold bg-[#0b0e13] px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.25em] text-brand-gold2 transition-all hover:bg-brand-gold hover:text-brand-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 focus-visible:ring-offset-brand-bg"
                        >
                            Speak with an agent · 855.900.7405
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
